import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Input, Modal, ModalBody } from "reactstrap";

const CreateFolder = ({
  show,
  folderName,
  parentId,
  _id,
  submitButton,
  onCloseClick,
  isEdit,
}: {
  show: boolean;
  folderName: string; // Accept folderName as a prop
  parentId?: any;
  _id?: any;
  isEdit: boolean;
  submitButton: (folderName: string, parentId?: string, _id?: string) => void;
  onCloseClick: () => void;
}) => {
  const [folderInput, setFolderInput] = useState(folderName); // Initialize state with folderName prop
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    setFolderInput(folderName);
  }, [folderName]);

  // Handle folder name change
  const handleFolderNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    if (input.length <= 40) { 
      setFolderInput(input);
      setErrorMessage(""); 
    }
  };

  const validateInput = async () => {
    const trimmedInput = folderInput.trim();
    if (trimmedInput.length === 0) {
      setErrorMessage("Required");
      return false;
    }
  
    if (trimmedInput.length > 40) {
      setErrorMessage("Required and must not exceed 40 characters");
      return false;
    }
  

    return true;
  };
  

  const handleSubmit = async () => {
    const isValid = await validateInput();
    if (isValid) {
      setIsLoading(true); 
      try {
        await submitButton(folderInput, parentId, _id);
        setFolderInput("");
        setErrorMessage("");
      } catch (error) {
        console.error("Error during submission:", error);
      } finally {
        setIsLoading(false); // Stop loading
      }
    }
  };

  const handleClose = () => {
    setErrorMessage("");
    setFolderInput("");
    onCloseClick();
  };

  return (
    <Modal isOpen={show} toggle={handleClose} centered={true} backdrop="static" className="smallModal">
      <ModalBody className="py-3 px-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>{isEdit ? "Rename Folder" : "Create Folder"}</h4>
          <i
            className="bx bx-x fs-2 cursor-pointer"
            data-testing-Id="closeIconbackground_createFolder"
            style={{ color: "#CACACA" }}
            onClick={handleClose}
          ></i>
        </div>
        <div className="mb-3" style={{ position: "relative" }}>
          <Input
            type="text"
            placeholder="Folder name, no more than 40 characters"
            value={folderInput}
            onChange={handleFolderNameChange}
            data-testing-id="newFolder_mediaCenter"
            className={errorMessage ? "input-error" : ""}
              style={{ paddingRight: "60px" }}
            />
            <span
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "12px",
                color: folderInput.length > 40 ? "red" : "black",
              }}
            >
              {folderInput.length} / 40
            </span>
          {errorMessage && (
            <div style={{ color: "red", fontSize: "12px", marginTop: "0px" }}>
              {errorMessage}
            </div>
          )}
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <button
              className="btn btn-outline-dark me-3 lightGrayButton"
              type="button"
              data-testing-Id="cancelButton_createFolder"
              onClick={handleClose}
              disabled={isLoading} // Disable cancel when loading
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-testing-Id="submitButton_createFolder"
              onClick={handleSubmit}
              disabled={isLoading} // Disable submit when loading
            >
              {isLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>

      </ModalBody>
    </Modal>
  );
};

CreateFolder.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.bool.isRequired,
  folderName: PropTypes.string.isRequired, // Define folderName as a required prop
  parentId: PropTypes.string,
  submitButton: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
};

export default CreateFolder;
